/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {defaultConfig as ɵa} from './lib/config';
export {NgxCookieBannerService as ɵb} from './lib/services/ngx-cookie-banner.service';